import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandLogo from "@/components/common/BrandLogo";

/**
 * Shared auth shell (login + register): back link, header, split card area, footer.
 */
export default function AuthPageLayout({
  children,
  showBack = true,
  layoutTestId = "auth-page-layout",
  navPrompt = "Already have an account?",
  navLinkLabel = "Log in",
  navLinkTo = "/login",
  navLinkTestId = "auth-nav-login",
}) {
  return (
    <div className="min-h-screen bg-cm-surface flex flex-col" data-testid={layoutTestId}>
      <header className="border-b border-[var(--cm-border)] bg-white">
        <div className="cm-container flex items-center justify-between h-[64px] lg:h-[72px] gap-4">
          <div className="flex items-center gap-4 min-w-0">
            {showBack && (
              <Link
                to="/"
                data-testid="auth-back-home"
                className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-cm-grey hover:text-cm-blue transition shrink-0"
              >
                <ArrowLeft size={18} strokeWidth={2} />
                <span className="hidden sm:inline">Back to home</span>
              </Link>
            )}
            <Link to="/" data-testid="auth-nav-logo" className="shrink-0">
              <BrandLogo size="md" testId="auth-logo-img" />
            </Link>
          </div>
          <div className="flex items-center gap-3 text-[14px] shrink-0">
            <span className="hidden md:inline text-cm-grey">{navPrompt}</span>
            <Link
              to={navLinkTo}
              data-testid={navLinkTestId}
              className="font-bold text-cm-blue hover:text-cm-blue-deep transition whitespace-nowrap"
            >
              {navLinkLabel}
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-8 lg:py-12">
        <div className="w-full max-w-[1040px]">{children}</div>
      </main>

      <footer className="py-4 border-t border-[var(--cm-border)] bg-white">
        <div className="cm-container flex flex-wrap items-center justify-between gap-2 text-[11px] text-cm-grey">
          <span>© {new Date().getFullYear()} CoinMBX</span>
          <div className="flex items-center gap-3">
            <Link to="/terms" className="hover:text-cm-blue">
              Terms
            </Link>
            <Link to="/privacy" className="hover:text-cm-blue">
              Privacy
            </Link>
            <Link to="/support" className="hover:text-cm-blue">
              Support
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
